import { createContext, useContext } from "react";

/**
 * Type defining all the possible supported types of notifications
 */
export type NotificationType = "success" | "error" | "warning" | "info" | "none";

/**
 * Interface to define the notifications context properties.
 */
export interface NotificationContextProps {
  pushNotification: (message: string, type: NotificationType, duration?: number) => void;
}

/**
 * Context for notifications, which components can use to push notifications.
 */
export const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

/**
 * Function to get the notifications context.
 * @returns The notifications context
 */
export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotifications must be used within a NotificationProvider");
  }
  return context;
};
